import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

function NavItem(props: { link: string, children: ReactNode | ReactNode[] }) {
    return (
        <Link
        to={props.link}
        type="button"
        className="inline-flex items-center px-6 py-3 border-none text-base rounded-xl text-dark-grey bg-none hover:bg-light-grey-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-logo-green"
      >
        {props.children}
      </Link>
    );
}

export default NavItem;